import { DefaultTheme, css } from 'styled-components';

import { pxToRem } from 'utils/css';
import { LaunchDarklyFlag, LaunchDarklyFlagsObject } from 'utils/launchdarkly';

import { theme as brandTheme } from './brand-theme';
import { DesignTokens, designTokens } from './constants/design-tokens';
import { IFontConfig } from './constants/fonts';

const BASE_FONT_SIZE = 16;

export const theme: DefaultTheme = {
  ...brandTheme,
  pxToRem: pxToRem(BASE_FONT_SIZE),
  token(tokenName: keyof DesignTokens) {
    return designTokens[tokenName];
  },
  primaryBackground: designTokens['background-default'],
  cardOutline: null,
};

export const createTheme = (
  fontConfig: IFontConfig,
  flags: LaunchDarklyFlagsObject
): DefaultTheme => {
  const isWhiteBackground = flags[LaunchDarklyFlag.ENABLE_WHITE_BACKGROUND];
  return {
    ...theme,
    pxToRem: pxToRem(fontConfig.baseFontSize),
    primaryBackground: isWhiteBackground
      ? designTokens['background-white']
      : designTokens['background-default'],
    cardOutline: isWhiteBackground ? designTokens['border-card'] : null,
    flags,
  };
};

const backgroundColorByFlag = (isWhiteBGFlagOn?: boolean, theme?: DefaultTheme) => {
  return isWhiteBGFlagOn ? theme?.primaryBackground : Styles.color.white;
};

export const backgroundColorMixin = css<{ isWhiteBGFlagOn?: boolean }>`
  background-color: ${p => backgroundColorByFlag(p.isWhiteBGFlagOn, p.theme)};
`;
